/* Ixaria: PLP-ul (sections/ixaria-plp.liquid) — filtrele si cardurile.

   Datele vin din pagina (#ixp-data, snippets/ixaria-plp-data.liquid), cate un
   obiect pe produs. Filtrele lucreaza pe FORME, nu pe produse: o familie
   (Natalie: canapea, colțare cu insulă, colțare cu longchair) intra in rezultate
   daca macar una din formele ei trece de TOATE filtrele puse. Cardul arata
   atunci forma aceea (cea mai ieftina dintre cele care trec): poza ei, numele
   si pretul ei „de la", iar linkul deschide produsul pe ea (?forma=…, ca
   ixaria-pdp.js). Cand trec toate formele, cardul ramane cel obisnuit.

   Cu setarea „Un card pentru fiecare formă" o familie are cate un card pe forma
   (data-ixp-sid): fiecare se arata cat forma lui trece de filtre, iar numerele
   din filtre numara formele (Engine.perShape).

   Totul se face in pagina, fara reincarcare: o colectie are cateva zeci de
   produse, toate sunt deja in HTML. Filtrele puse stau in adresa
   (?tip=canapea&pret=2000-5000…), ca un link trimis sa arate aceleasi rezultate.

   Ce fapte are o forma (ixpFacts) — primul raspuns gasit castiga:
     tip        numele formei: „insula" → colțar cu insulă, „longchair" / „șezlong"
                → colțar cu longchair, „Colțar…" → colțar, altfel canapea.
                Un produs fara forme: canapea; colțar daca titlul incepe asa, iar
                textele lui spun ce fel („peninsulă", „șezlong").
     directie   „stanga" / „dreapta" din numele formei, altfel simetric. Un colțar
                clasic: amandoua daca se face „pe stânga sau pe dreapta", altfel
                niciuna (nu stim).
     locuri     „N locuri" din numele formei; apoi custom.numar_locuri; etichetele
                „Canapea N locuri" / „Colțar N locuri" (toate); handle-ul / titlul
                („…-2-locuri-…", „doua locuri").
     marime     dimensiunile formei din aplicatie (latime → lungime, adancime →
                latime; inaltimea se citeste, dar nu mai e filtru); altfel textul cu
                dimensiuni al produsului.
     extensibila  custom.extensibila; „canapea fixă" in texte → nu; locul de
                dormit al formei (aplicatia) → da; un produs cu loc de dormit doar
                pe unele forme → celelalte nu; altfel „extensibil" / „loc de dormit"
                in texte.
     depozitare custom.depozitare; volumul lazii formei (aplicatia) → da, iar un
                produs cu volum doar pe unele forme → celelalte nu; „lada de
                lenjerie: NU" / „fără ladă" → nu; „depozitare" in descrierea formei
                sau in texte.
     fermitate  custom.fermitate_sezut (Moale / Mediu / Ferm, unul sau mai multe);
                altfel etichetele „Șezut Moale", „Șezut Fermitate Medie".
     pret       pretul „de la" al formei (cea mai ieftina tesatura).
     culoare    familiile de culoare ale produsului (Bej, Maro, Roz, Roșu, Albastru,
                Verde, Gri, Negru), din HEX-ul fiecarei culori a lui: metaobiectele
                „Culoare swatch" (harta data-ixp-colors a sectiunii), dupa ID-ul din
                aplicatie (variant_config.materials.colorIds: culorile cu poze, plus
                toate celelalte ale colectiilor lor, ca in configurator) sau, la un
                produs clasic, dupa numele din optiunea Color („Manila 02"). Toate
                formele au culorile produsului; un produs fara culori cunoscute nu
                trece de filtru.

   Cardurile (dupa Figma, 2026-10-12): galeria se trage lateral, cu bara de progres jos
   (bindCards; cu mouse-ul se trag si ea, si banda de beneficii); culorile sunt 5 placi cu
   pozele lor (assets/ixaria-swatch-thumbs.js) si „+N culori" (paintColors); pe telefon butonul
   rosu din colt deschide foaia cand „Toate filtrele" a iesit din ecran (bindFab). Sortarea
   e primul grup din foaie.

   Fisierul se poate incarca si in Node (module.exports), ca regulile sa poata
   fi verificate pe datele adevarate fara browser. */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.boot();
})(function () {
  'use strict';

  /* ── Texte ──────────────────────────────────────────────────────────── */
  function norm(s) {
    return String(s == null ? '' : s)
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }
  /* la fel ca ixSlug din ixaria-pdp.js: „Coltar cu insula pe stanga" → coltar-cu-insula-pe-stanga */
  function slug(s) {
    return norm(s).replace(/[^a-z0-9]+/g, ' ').trim().replace(/ /g, '-');
  }
  function num(v) {
    var n = parseFloat(v);
    return isFinite(n) && n > 0 ? n : null;
  }
  var WORDS = { coltar: 'colțar', insula: 'insulă', stanga: 'stânga', sezlong: 'șezlong' };
  /* „Coltar cu insula pe stanga" (cum vine din Shopify) → „Colțar cu insulă pe stânga" */
  function pretty(name) {
    var s = String(name || '').trim().toLowerCase().replace(/[a-z]+/g, function (w) {
      return WORDS[w] || w;
    });
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  /* 1 produs, 2 produse, 20 de produse (cu „de" de la 20 in sus, ca in romana) */
  function plural(n, one, many) {
    if (n === 1) return '1 ' + one;
    var r = n % 100;
    return n + (n > 0 && (r === 0 || r >= 20) ? ' de ' : ' ') + many;
  }

  var NF0 = null;
  try {
    NF0 = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 });
  } catch (e) {}
  /* „6.265 lei": fara zecimale, ca restul preturilor din tema */
  function money(cents) {
    var v = Math.round(cents / 100);
    return (NF0 ? NF0.format(v) : String(v)) + ' lei';
  }
  function fmt(v) {
    return NF0 ? NF0.format(v) : String(Math.round(v));
  }

  /* ── Faptele unei forme ─────────────────────────────────────────────── */
  var NUM_WORDS = { unu: 1, doua: 2, doi: 2, trei: 3, patru: 4, cinci: 5, sase: 6 };
  function seatsIn(s) {
    var n = norm(s).replace(/-/g, ' ');
    var m = /\b(\d+) ?locuri\b/.exec(n) || /\b(unu|doua|doi|trei|patru|cinci|sase) locuri\b/.exec(n);
    if (!m) return null;
    return NUM_WORDS[m[1]] || parseInt(m[1], 10) || null;
  }
  function shapeType(name) {
    var n = norm(name);
    /* toate colțarele sunt un singur tip, „Colțar" (cerut 2026-10-08: doar Canapea si Colțar,
       fara insulă / longchair / simetric) */
    if (/^colt|insula|long ?chair|sezlong|chaise/.test(n)) return 'coltar';
    return 'canapea';
  }
  function shapeDir(name) {
    var n = norm(name);
    if (/\bstanga\b/.test(n)) return 'stanga';
    if (/\bdreapta\b/.test(n)) return 'dreapta';
    return 'simetric';
  }
  function bool(v) {
    if (v === true || v === false) return v;
    var k = norm(v);
    if (/^(da|yes|true|1)$/.test(k)) return true;
    if (/^(nu|no|false|0)$/.test(k)) return false;
    return null;
  }
  var FIRM = { moale: 'moale', mediu: 'mediu', medie: 'mediu', medium: 'mediu', ferm: 'ferm', ferma: 'ferm' };
  function firmList(v) {
    var out = [];
    (Array.isArray(v) ? v : v == null ? [] : [v]).forEach(function (x) {
      String(x).split(/[,;\/|]/).forEach(function (part) {
        var k = FIRM[norm(part).replace(/[^a-z]/g, '')];
        if (k && out.indexOf(k) === -1) out.push(k);
      });
    });
    return out;
  }

  /* Dimensiunile din textul unui produs clasic: „Dimensiuni: 195*90*96cm",
     „Lungime totală: 250 cm", „Adâncime totală: 100 cm", „Înălțime spătar cu tot
     cu perne: 90cm", „Dimensiuni: 290x185cm"… Lungime = lungimea canapelei;
     latime = adancimea totala la o canapea, dar la un colțar latura insulei
     („Lățime totală: 175cm", ca adancimea formelor de colțar din aplicatie);
     inaltime = cea mai mare inaltime a spatarului (nu a sezutului sau a bratului). */
  function parseDims(text, corner) {
    var t = norm(text);
    var trip = /(\d{2,3}) ?[*x×] ?(\d{2,3}) ?[*x×] ?(\d{2,3})/.exec(t);
    var pair = /(?:dimensiuni(?: totale)?|lungime(?: totala)?) ?:? ?(\d{2,3}) ?[*x×] ?(\d{2,3})(?! ?[*x×] ?\d)/.exec(t);
    function first(res) {
      for (var i = 0; i < res.length; i++) {
        var m = res[i].exec(t);
        if (m) return parseInt(m[1], 10);
      }
      return null;
    }
    var depth = [/adancime totala ?: ?(\d{2,3})/, /adancime ?: ?(\d{2,3})/, /latime ?\(adancime\) ?: ?(\d{2,3})/];
    var wide = [/latime totala ?: ?(\d{2,3})/, /latime ?: ?(\d{2,3})/];
    var L = first([/lungime(?: totala)? ?: ?(\d{2,3})/]) || (trip && +trip[1]) || (pair && +pair[1]);
    var W = corner
      ? first(wide) || (pair && +pair[2]) || (trip && +trip[2]) || first(depth)
      : first(depth) || (trip && +trip[2]) || (pair && +pair[2]);
    var H = trip ? +trip[3] : null;
    var re = /inaltime\w*([^:|\d]{0,40}?) ?:? ?(\d{2,3}) ?cm/g, m;
    while ((m = re.exec(t))) {
      var lab = m[1];
      if (/sezut|picioare/.test(lab) || (/brat/.test(lab) && !/spatar/.test(lab))) continue;
      H = Math.max(H || 0, +m[2]);
    }
    return { L: L || null, W: W || null, H: H || null };
  }

  /* Locurile produsului, ca lista: un colțar clasic poate fi „Colțar 4 locuri" si
     „Colțar 5 locuri" (Natasha). */
  function productSeats(p) {
    var out = [];
    var add = function (n) {
      if (n > 0 && out.indexOf(n) === -1) out.push(n);
    };
    /* custom.numar_locuri: un numar, o lista sau text — „3, 4" si „3-4" inseamna 3 si 4 */
    var mf = p.mf && p.mf.seats;
    (Array.isArray(mf) ? mf : [mf]).forEach(function (v) {
      String(v == null ? '' : v).replace(/(\d+)\s*[-–]\s*(\d+)|\d+/g, function (m, a, b) {
        if (a) for (var n = +a; n <= +b && n - a < 10; n++) add(n);
        else add(+m);
        return m;
      });
    });
    if (out.length) return out;
    (p.tags || []).forEach(function (t) { add(seatsIn(t)); });
    if (out.length) return out;
    add(seatsIn(p.handle) || seatsIn(p.title));
    return out;
  }
  /* „Șezut Fermitate Medie", „Șezut Moale" (etichetele produselor clasice) */
  function tagFirm(tags) {
    var out = [];
    (tags || []).forEach(function (t) {
      var m = /^sezut (?:fermitate )?(moale|medie|mediu|ferma?)$/.exec(norm(t)) || /^fermitate (?:sezut )?(moale|medie|mediu|ferma?)$/.exec(norm(t));
      var k = m && FIRM[m[1]];
      if (k && out.indexOf(k) === -1) out.push(k);
    });
    return out;
  }

  /* Familia unei culori, ca filtrul de culoare din configurator (cfg_colorFamilyRO in
     ixaria-configurator.js, cu aceleasi praguri; daca se schimba acolo, se schimba si
     aici): pe CIE L*C*h, nu pe HSL, care dadea olivul drept galben. */
  var FAMILY_ORDER = ['bej', 'maro', 'roz', 'rosu', 'albastru', 'verde', 'gri', 'negru'];
  function linear(c) {
    c /= 255;
    return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }
  function labF(t) {
    return t > 0.008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116;
  }
  /* CIE Lab al unui #RRGGBB, sau null */
  function lab(hex) {
    var m = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!m) return null;
    var n = parseInt(m[1], 16);
    var r = linear(n >> 16 & 255), g = linear(n >> 8 & 255), b = linear(n & 255);
    var fx = labF((r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.9505);
    var fy = labF(r * 0.2126 + g * 0.7152 + b * 0.0722);
    var fz = labF((r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.089);
    return { l: 116 * fy - 16, a: 500 * (fx - fy), b: 200 * (fy - fz) };
  }
  function colorFamily(hex) {
    var lb = lab(hex);
    if (!lb) return '';
    var l = lb.l, A = lb.a, B = lb.b;
    var c = Math.sqrt(A * A + B * B), h = Math.atan2(B, A) * 180 / Math.PI;
    if (h < 0) h += 360;
    if (l < 12) return 'negru';
    /* nuantele reci (verde → albastru) au nevoie de mai multa croma ca sa nu para gri */
    var cool = h >= 100 && h < 310;
    if (c < (cool ? 12 : 7)) return l > 60 ? 'bej' : 'gri';
    /* un roșu are nevoie de croma: sub 25 banda 17–50 e maro, taupe si gri-bej */
    if (h >= 17 && h < 50) return c >= 25 ? 'rosu' : l >= 48 ? 'bej' : 'maro';
    if (h >= 50 && h < 100) return l >= 48 ? 'bej' : 'maro';
    if (h >= 100 && h < 220) return 'verde';
    if (h >= 220 && h < 310) return 'albastru';
    /* rozurile foarte inchise si aproape fara nuanta sunt maro inchis (Manila 06/07, Zoya 04) */
    return l < 40 && c < 15 ? 'maro' : 'roz';
  }
  /* Placile produsului: { id, name, hex, fam, photo, variant }. swatch = harta din pagina
     (swatchMap): { ids: { idAplicatie: placa }, names: { „manila 02": placa }, cols: { colectie: [placi] } }.
     Un produs configurabil are in Shopify doar culorile cu poze (patru din fiecare colectie),
     dar in configurator se face in toate culorile colectiilor lui: le primeste pe toate, cele
     cu poze intai (photo). variant: la un produs clasic, varianta Shopify in culoarea aceea. */
  function productPalette(p, swatch) {
    var ids = (swatch && swatch.ids) || {}, names = (swatch && swatch.names) || {}, cols = (swatch && swatch.cols) || {};
    var out = [], seen = {}, offered = [];
    var add = function (sw, variant, photo) {
      if (!sw || seen[sw.name]) return;
      var fam = colorFamily(sw.hex);
      if (!fam) return;
      seen[sw.name] = true;
      out.push({ id: sw.id || '', name: sw.name, hex: sw.hex, fam: fam, photo: !!photo, variant: variant || null });
    };
    (p.col || []).forEach(function (id) {
      var sw = ids[id];
      add(sw, null, true);
      if (sw && sw.col && offered.indexOf(sw.col) === -1) offered.push(sw.col);
    });
    offered.forEach(function (c) {
      (cols[c] || []).forEach(function (sw) { add(sw); });
    });
    (p.colN || []).forEach(function (v) {
      var name = Array.isArray(v) ? v[0] : v;
      add(names[norm(name)], Array.isArray(v) ? v[1] : null);
    });
    return out;
  }
  /* harta din pagina (data-ixp-colors: [[idAplicatie, nume, hex, colectie], …]) → { ids, names, cols } */
  function swatchMap(list) {
    var map = { ids: {}, names: {}, cols: {} };
    (Array.isArray(list) ? list : []).forEach(function (row) {
      if (!row || !row[1] || !row[2]) return;
      var sw = { id: row[0] ? String(row[0]) : '', name: String(row[1]), hex: String(row[2]).toUpperCase(), col: row[3] ? String(row[3]) : '' };
      if (row[0]) map.ids[row[0]] = sw;
      map.names[norm(sw.name)] = sw;
      if (sw.col) (map.cols[sw.col] = map.cols[sw.col] || []).push(sw);
    });
    return map;
  }

  /* kind: „colt" in PLP-ul de colțare — acolo conteaza doar colțarele unei familii
     (canapeaua ei nu e un colțar), ca in ixaria-context-shape.liquid; „canapea" in cel de
     canapele — acolo doar canapelele. */
  function ixpFacts(p, kind, swatch) {
    var mf = p.mf || {}, kw = p.kw || {};
    var palette = productPalette(p, swatch);
    var colors = FAMILY_ORDER.filter(function (f) {
      return palette.some(function (c) { return c.fam === f; });
    });
    var mfExt = bool(mf.ext), mfSt = bool(mf.storage);
    var firm = firmList(mf.firm);
    if (!firm.length) firm = tagFirm(p.tags);
    var pSeats = productSeats(p);
    var raw = (p.shapes || []).filter(function (s) {
      return s && s.name;
    });
    var implicit = !raw.length;
    if (implicit) {
      var d = p.dflt || {};
      raw = [{ id: '', name: '', price: p.price, cmp: p.cmp, dims: d.dimensions, sleep: d.sleepingArea, storage: d.storageVolume, st: false, img: '' }];
    }
    var anySleep = raw.some(function (s) {
      return s.sleep;
    });
    var anyStorage = raw.some(function (s) {
      return num(s.storage);
    });
    /* Un produs fara forme e un colțar daca titlul incepe asa (pe ce parte se
       face spun textele lui sau titlul: „…pe stânga sau pe dreapta" trece
       la amandoua, „Colțar bucătărie Andi stânga" la stânga, fara nicio vorba la
       niciuna); o canapea daca tipul, handle-ul sau titlul o spun, sau daca e din
       aplicatie; altfel (pat, fotoliu, banchetă) nu are tip si nici directie. */
    var title = norm(p.title), ptype = norm(p.type);
    var corner = /^colt/.test(title);
    /* paturile si fotoliile au tipul lor (cerut 2026-10-08, pentru PLP-ul cu toate produsele):
       titlul incepe cu „Pat" / „Fotoliu", sau tipul de produs din Shopify e Paturi / Fotolii.
       O canapea extensibila („Canapea … pat") ramane canapea: titlul ei incepe cu „Canapea". */
    var bed = !corner && (/^pat\b/.test(title) || /^pat(uri)?\b/.test(ptype));
    var armchair = !corner && !bed && (/^fotoli/.test(title) || /\bfotoli/.test(ptype));
    var sofa = !bed && !armchair && (corner || p.app || /canap|sofa/.test(norm(p.type + ' ' + p.handle + ' ' + p.title)));
    /* partea din titlu, altfel din handle („coltar-bucatarie-andrei-stanga", titlul fara ea) */
    var named = title + ' | ' + norm(p.handle).replace(/-/g, ' ');
    var titleDir = /\bstanga\b/.test(title) ? 'stanga' : /\bdreapta\b/.test(title) ? 'dreapta' : /\bstanga\b/.test(named) ? 'stanga' : /\bdreapta\b/.test(named) ? 'dreapta' : '';
    var implicitType = corner ? 'coltar' : bed ? 'pat' : armchair ? 'fotoliu' : sofa ? 'canapea' : '';
    var implicitDir = corner ? (kw.both ? ['stanga', 'dreapta'] : titleDir ? [titleDir] : []) : sofa ? ['simetric'] : [];
    /* „Loc de dormit" in texte inseamna extensibila doar la o canapea (un pat are si el) */
    var textExt = !!kw.ext || (sofa && !!kw.sleep);
    var textDims = implicit && !(raw[0].dims && raw[0].dims.width) && p.dimText ? parseDims(p.dimText, corner) : null;

    var shapes = raw.map(function (s) {
      var n = s.name, dm = s.dims && s.dims.width ? s.dims : null, own = n && seatsIn(n);
      return {
        id: s.id || '',
        name: n,
        label: n ? pretty(n) : '',
        slug: n ? slug(n) : '',
        type: n ? (bed ? 'pat' : armchair ? 'fotoliu' : shapeType(n)) : implicitType,
        dir: n ? [shapeDir(n)] : implicitDir,
        seats: own ? [own] : pSeats,
        L: dm ? num(dm.width) : textDims && textDims.L,
        W: dm ? num(dm.depth) : textDims && textDims.W,
        H: dm ? num(dm.height) : textDims && textDims.H,
        ext: mfExt != null ? mfExt : kw.fix ? false : s.sleep ? true : anySleep ? false : textExt,
        storage: mfSt != null ? mfSt : num(s.storage) ? true : anyStorage || kw.stN ? false : !!(s.st || kw.stY),
        firm: firm,
        colors: colors,
        price: s.price != null ? +s.price : +p.price,
        cmp: s.price != null ? (s.cmp != null ? +s.cmp : null) : p.cmp != null ? +p.cmp : null,
        img: s.img || '',
        /* galeria formei (doar fara „Un card pentru fiecare formă"; altfel ajunge prima poza) */
        imgs: Array.isArray(s.imgs) && s.imgs.length ? s.imgs : s.img ? [s.img] : []
      };
    });
    /* In Colțare doar colțarele, in Canapele doar canapelele (cerut 2026-10-08), ca in
       snippets/ixaria-plp-shapes.liquid: un produs fara nicio forma de felul colectiei
       ramane fara forme si nu apare. */
    if (kind === 'colt') {
      shapes = shapes.filter(function (s) { return !/^(canapea|pat|fotoliu)$/.test(s.type); });
    } else if (kind === 'canapea') {
      shapes = shapes.filter(function (s) { return !/^(coltar|pat$|fotoliu$)/.test(s.type); });
    }
    /* cardul de la incarcare: forma de context (colțarul, in PLP-ul de colțare) sau tot produsul */
    var ctx = null;
    if (p.ctx) {
      for (var i = 0; i < shapes.length; i++) if (shapes[i].name === p.ctx) ctx = shapes[i];
    }
    return {
      i: p.i,
      id: p.id,
      handle: p.handle,
      title: p.title,
      url: p.url,
      shapes: shapes,
      implicit: implicit,
      palette: palette,
      basePrice: ctx ? ctx.price : +p.price,
      reviews: +p.reviews || 0,
      rating: +p.rating || 0
    };
  }

  /* ── Filtrele ───────────────────────────────────────────────────────── */
  var FILTERS = {
    tip: {
      kind: 'opts',
      order: ['canapea', 'coltar', 'pat', 'fotoliu'],
      labels: { canapea: 'Canapea', coltar: 'Colțar', pat: 'Pat', fotoliu: 'Fotoliu' },
      vals: function (s) {
        return s.type ? [s.type] : [];
      }
    },
    locuri: {
      kind: 'opts',
      vals: function (s) {
        return s.seats.map(String);
      },
      label: function (v) {
        return +v === 1 ? '1 persoană' : v + ' persoane';
      }
    },
    fermitate: {
      kind: 'opts',
      order: ['moale', 'mediu', 'ferm'],
      labels: { moale: 'Moale', mediu: 'Mediu', ferm: 'Ferm' },
      vals: function (s) {
        return s.firm;
      }
    },
    caracteristici: {
      kind: 'opts',
      all: true /* „Extensibilă" + „Spațiu de depozitare" = amandoua */,
      order: ['extensibila', 'depozitare'],
      labels: { extensibila: 'Extensibilă', depozitare: 'Spațiu de depozitare' },
      vals: function (s) {
        var v = [];
        if (s.ext) v.push('extensibila');
        if (s.storage) v.push('depozitare');
        return v;
      }
    },
    directie: {
      kind: 'opts',
      order: ['stanga', 'simetric', 'dreapta'],
      labels: { stanga: 'Stânga', simetric: 'Simetric', dreapta: 'Dreapta' },
      vals: function (s) {
        return s.dir;
      }
    },
    culoare: {
      kind: 'opts',
      order: FAMILY_ORDER,
      labels: { bej: 'Bej', maro: 'Maro', roz: 'Roz', rosu: 'Roșu', albastru: 'Albastru', verde: 'Verde', gri: 'Gri', negru: 'Negru' },
      /* cercul fiecarei familii, culorile filtrului de culoare din configurator
         (FAMILY_CHIP_STYLE in ixaria-configurator.js) */
      dots: { bej: '#D8BE8E', maro: '#8A5A36', roz: '#E97FAF', rosu: '#D23B30', albastru: '#3470D0', verde: '#3F9A55', gri: '#8E9298', negru: '#1D1D1F' },
      /* culoarea cu care cardul deschide produsul se cauta langa bulina familiei, iar unde
         bulina nu e un ton de tapiterie, langa unul ales: la Maro un maro neutru ca Luna 14,
         nu coniacul bulinei (care alegea Manila 31, portocaliu) */
      pick: { maro: '#635047' },
      vals: function (s) {
        return s.colors || [];
      }
    },
    /* ends: „Minim" / „Maxim" deasupra valorilor; glisoarele de marime le au fara (cerut 2026-10-07) */
    pret: { kind: 'range', unit: 'lei', step: 50, label: 'Preț', ends: true, val: function (s) { return s.price / 100; } },
    lungime: { kind: 'range', unit: 'cm', step: 5, label: 'Lungime', val: function (s) { return s.L; } },
    latime: { kind: 'range', unit: 'cm', step: 5, label: 'Lățime', val: function (s) { return s.W; } }
    /* Înălțimea nu mai e filtru (scoasa 2026-10-07); forma o are inca (s.H), din aplicatie sau din text */
  };
  var KEYS = ['tip', 'culoare', 'locuri', 'fermitate', 'caracteristici', 'pret', 'directie', 'lungime', 'latime'];
  /* blocurile sectiunii (un grup de filtre fiecare) → filtrele din el */
  var FACETS = {
    tip: ['tip'], locuri: ['locuri'], fermitate: ['fermitate'], caracteristici: ['caracteristici'],
    pret: ['pret'], directie: ['directie'], marime: ['lungime', 'latime'], culoare: ['culoare']
  };
  var TITLES = {
    tip: 'Tip de produs', locuri: 'Are loc pentru', fermitate: 'Fermitate șezut', caracteristici: 'Caracteristici',
    pret: 'Preț', directie: 'Direcție canapea', marime: 'Mărime', culoare: 'Culoare'
  };

  function Engine(products) {
    this.products = products;
    this.sel = {};
    this.rng = {};
    this.options = {};
    this.bounds = {};
    var self = this;
    KEYS.forEach(function (k) {
      var f = FILTERS[k];
      if (f.kind === 'opts') {
        var seen = [];
        products.forEach(function (p) {
          p.shapes.forEach(function (s) {
            f.vals(s).forEach(function (v) {
              if (seen.indexOf(v) === -1) seen.push(v);
            });
          });
        });
        self.options[k] = f.order
          ? f.order.filter(function (v) { return seen.indexOf(v) !== -1; })
          : seen.sort(function (a, b) { return a - b; });
        self.sel[k] = [];
        /* O singura optiune, pe care o au toate produsele (intr-o colectie de paturi
           totul e „Simetric"), nu poate ingusta nimic: grupul nu se arata. */
        if (self.options[k].length === 1) {
          var only = self.options[k][0];
          var all = products.every(function (p) {
            return p.shapes.some(function (s) { return f.vals(s).indexOf(only) !== -1; });
          });
          if (all) self.options[k] = [];
        }
        /* Tipul ajuta doar cand sunt cel putin doua feluri, iar directia doar cand
           exista ceva pe stânga sau pe dreapta (in Fotolii, o singura canapea „Simetric"
           nu e o alegere). */
        if (k === 'tip' && self.options[k].length < 2) self.options[k] = [];
        if (k === 'directie' && !self.options[k].some(function (v) { return v !== 'simetric'; })) self.options[k] = [];
      } else {
        var lo = Infinity, hi = -Infinity;
        products.forEach(function (p) {
          p.shapes.forEach(function (s) {
            var x = f.val(s);
            if (x == null) return;
            if (x < lo) lo = x;
            if (x > hi) hi = x;
          });
        });
        if (lo < hi) self.bounds[k] = [Math.floor(lo / f.step) * f.step, Math.ceil(hi / f.step) * f.step];
      }
    });
  }
  Engine.prototype.has = function (k) {
    return FILTERS[k].kind === 'opts' ? this.options[k].length > 0 : !!this.bounds[k];
  };
  Engine.prototype.isOn = function (k) {
    return FILTERS[k].kind === 'opts' ? this.sel[k].length > 0 : !!this.rng[k];
  };
  Engine.prototype.anyOn = function () {
    for (var i = 0; i < KEYS.length; i++) if (this.isOn(KEYS[i])) return true;
    return false;
  };
  Engine.prototype.activeCount = function () {
    var self = this, n = 0;
    KEYS.forEach(function (k) {
      n += FILTERS[k].kind === 'opts' ? self.sel[k].length : self.rng[k] ? 1 : 0;
    });
    return n;
  };
  Engine.prototype.passes = function (s, k) {
    var f = FILTERS[k];
    if (f.kind === 'opts') {
      var sel = this.sel[k];
      if (!sel.length) return true;
      var vals = f.vals(s);
      return f.all
        ? sel.every(function (v) { return vals.indexOf(v) !== -1; })
        : sel.some(function (v) { return vals.indexOf(v) !== -1; });
    }
    var r = this.rng[k];
    if (!r) return true;
    var x = f.val(s);
    return x != null && x >= r[0] && x <= r[1];
  };
  /* formele produsului care trec de toate filtrele (in afara de `except`) */
  Engine.prototype.shapesFor = function (p, except) {
    var self = this;
    return p.shapes.filter(function (s) {
      for (var i = 0; i < KEYS.length; i++) if (KEYS[i] !== except && !self.passes(s, KEYS[i])) return false;
      return true;
    });
  };
  /* Cate produse ar ramane cu optiunea v: intr-un grup „sau" se numara fara
     celelalte alegeri din grup; in Caracteristici („si") cu ele. */
  Engine.prototype.count = function (k, v) {
    var f = FILTERS[k], self = this, n = 0;
    this.products.forEach(function (p) {
      var hits = self.shapesFor(p, f.all ? null : k).filter(function (s) { return f.vals(s).indexOf(v) !== -1; }).length;
      /* cu un card pe forma se numara formele, ca numarul de carduri */
      n += self.perShape ? hits : hits ? 1 : 0;
    });
    return n;
  };
  /* O optiune aleasa care, cu celelalte filtre, nu mai aduce niciun produs se scoate (si
     apoi se stinge): Colțar cu insulă + Colțar simetric, apoi „2 persoane" — colțarul
     simetric are 4 locuri, deci nu mai ramane ales (cerut 2026-10-07). Doar intr-un grup
     „sau" (nu in Caracteristici) si doar cat in grup ramane macar o alegere care aduce
     ceva: rezultatele raman aceleasi, optiunea scoasa nu aducea nimic; un grup golit
     de tot ar fi aratat brusc altceva. */
  Engine.prototype.prune = function () {
    var self = this;
    KEYS.forEach(function (k) {
      var f = FILTERS[k], sel = self.sel[k];
      if (f.kind !== 'opts' || f.all || !sel || sel.length < 2) return;
      var live = sel.filter(function (v) { return self.count(k, v) > 0; });
      if (live.length && live.length < sel.length) self.sel[k] = live;
    });
  };
  Engine.prototype.toggle = function (k, v) {
    var sel = this.sel[k], at = sel.indexOf(v);
    if (at === -1) sel.push(v);
    else sel.splice(at, 1);
  };
  /* un interval cat toata plaja nu e un filtru */
  Engine.prototype.setRange = function (k, lo, hi) {
    var b = this.bounds[k];
    if (!b) return;
    lo = Math.max(b[0], Math.min(lo, b[1]));
    hi = Math.max(b[0], Math.min(hi, b[1]));
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    if (lo <= b[0] && hi >= b[1]) delete this.rng[k];
    else this.rng[k] = [lo, hi];
  };
  Engine.prototype.clear = function (k) {
    if (FILTERS[k].kind === 'opts') this.sel[k] = [];
    else delete this.rng[k];
  };
  Engine.prototype.clearAll = function () {
    var self = this;
    KEYS.forEach(function (k) { self.clear(k); });
  };
  /* Ce arata fiecare card: nimic (iese din rezultate), cardul obisnuit (shape
     null: trec toate formele) sau forma potrivita — cea mai ieftina dintre cele
     care trec, la pret egal prima in ordinea din aplicatie. */
  Engine.prototype.results = function () {
    var self = this, on = this.anyOn();
    return this.products.map(function (p) {
      var m = self.shapesFor(p);
      if (!m.length) return { p: p, m: m, show: false };
      if (!on || m.length === p.shapes.length) return { p: p, m: m, show: true, shape: null, n: m.length, price: p.basePrice };
      var best = m.reduce(function (b, s) { return s.price < b.price ? s : b; });
      return { p: p, m: m, show: true, shape: best, n: m.length, price: best.price };
    });
  };

  /* Filtrele dupa colectie (cerut 2026-10-08): in Canapele „Tip de produs" nu se arata deloc
     (sunt toate canapele), nici in Colțare (doar „Colțar", fara „Canapea"),
     iar in Fotolii si HoReCa nu se arata „Caracteristici". kind vine din pagina (data-kind: „colt" /
     „canapea" / „fotoliu", dupa numele colectiei). */
  function limitTypes(engine, kind) {
    if ((kind === 'fotoliu' || kind === 'horeca') && engine.options.caracteristici) engine.options.caracteristici = [];
    if (!engine.options.tip) return;
    if (kind === 'canapea') engine.options.tip = [];
    else if (kind === 'colt') {
      engine.options.tip = engine.options.tip.filter(function (v) { return /^coltar/.test(v); });
      if (engine.options.tip.length < 2) engine.options.tip = [];
    }
  }

  /* ── Adresa ─────────────────────────────────────────────────────────── */
  var SORTS = ['pret-crescator', 'pret-descrescator'];
  function readQuery(engine, search) {
    var q = {};
    String(search || '').replace(/^\?/, '').split('&').forEach(function (pair) {
      if (!pair) return;
      var at = pair.indexOf('=');
      var key = decodeURIComponent(at === -1 ? pair : pair.slice(0, at));
      q[key] = at === -1 ? '' : decodeURIComponent(pair.slice(at + 1).replace(/\+/g, ' '));
    });
    KEYS.forEach(function (k) {
      var v = q[k];
      if (!v || !engine.has(k)) return;
      if (FILTERS[k].kind === 'opts') {
        /* linkuri vechi: tip=coltar-cu-insula / coltar-cu-longchair sunt acum „coltar" */
        if (k === 'tip') v = v.replace(/coltar-cu-[a-z]+/g, 'coltar');
        engine.sel[k] = v.split(',').filter(function (x, i, a) {
          return engine.options[k].indexOf(x) !== -1 && a.indexOf(x) === i;
        });
      } else {
        var m = /^(\d+)-(\d+)$/.exec(v);
        if (m) engine.setRange(k, +m[1], +m[2]);
      }
    });
    return SORTS.indexOf(q.ordine) !== -1 ? q.ordine : '';
  }
  /* Adresa cu filtrele de acum; ce alti parametri are (view=…, utm_…) raman. */
  function writeQuery(engine, sort, search) {
    /* inaltime: filtru scos, ramas in linkuri vechi — se curata la urmatoarea schimbare */
    var own = KEYS.concat(['ordine', 'page', 'inaltime']);
    var keep = String(search || '').replace(/^\?/, '').split('&').filter(function (pair) {
      if (!pair) return false;
      var key = decodeURIComponent(pair.split('=')[0]);
      return own.indexOf(key) === -1;
    });
    KEYS.forEach(function (k) {
      if (!engine.isOn(k)) return;
      var v = FILTERS[k].kind === 'opts' ? engine.sel[k].join(',') : engine.rng[k].join('-');
      keep.push(k + '=' + encodeURIComponent(v).replace(/%2C/g, ','));
    });
    if (sort) keep.push('ordine=' + sort);
    return keep.length ? '?' + keep.join('&') : '';
  }

  /* ── Linkul spre produs ─────────────────────────────────────────────── */
  /* Pagina de produs tine ultima alegere a clientului (localStorage, ixSaveCfgLink
     in ixaria-pdp.js), separat pentru colțar si pentru canapea, si o pune inapoi
     doar cand linkul nu alege el o forma. Linkul de aici alege forma, deci duce el
     mai departe culoarea pastrata — iar cand e chiar forma pastrata, tot linkul
     (si config-ul configuratorului). */
  var LINK_PREFIX = 'ix-pdp-link:';
  var LINK_MAX_AGE = 30 * 24 * 3600 * 1000;
  function savedLink(p, kind) {
    try {
      var s = JSON.parse(localStorage.getItem(LINK_PREFIX + p.id + '|' + kind) || 'null');
      if (s && s.q && Date.now() - (s.t || 0) <= LINK_MAX_AGE) return s.q;
    } catch (e) {}
    return null;
  }
  /* color: placa aleasa de filtrul de culoare (pickColor), care ia locul culorii
     pastrate; config-ul pastrat merge doar cu forma si culoarea lui */
  function shapeUrl(p, s, color) {
    var kind = norm(s.name).indexOf('colt') === 0 ? 'colt' : 'canapea';
    var saved = savedLink(p, kind) || {};
    var q = ['forma=' + encodeURIComponent(s.slug)];
    var cul = color ? slug(color.name) : saved.culoare;
    if (cul) q.push('culoare=' + encodeURIComponent(cul));
    if (saved.forma === s.slug && saved.config && (!color || saved.culoare === cul)) q.push('config=' + encodeURIComponent(saved.config));
    return p.url + (p.url.indexOf('?') === -1 ? '?' : '&') + q.join('&');
  }

  /* ── Pictograme (vazute de sus; spatarul sus) ───────────────────────── */
  var SVG_HEAD = '<svg viewBox="0 0 48 34" width="48" height="34" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true">';
  var ICONS = {
    canapea: '<rect x="5" y="9" width="38" height="16" rx="2.5"/><path d="M9.5 25V14h29v11"/>',
    coltar: '<path d="M7.5 5h33a2.5 2.5 0 0 1 2.5 2.5V19H18v8.5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 5 27.5v-20A2.5 2.5 0 0 1 7.5 5z"/><path d="M9.5 30V9.5h29V19"/>',
    /* pat vazut de sus (cerut 2026-10-08: mai mare, mai inalt si putin mai ingust, apoi ceva mai
       scurt: 26 x 36): doua
       perne si plapuma cu coltul intors, ca sa se vada ca e un pat. Are rama lui, mai inalta
       (TALL, mai jos), ca sa fie lung cat un pat. */
    pat: '<rect x="11" y="1" width="26" height="36" rx="3"/><rect x="14" y="4.5" width="9" height="6.5" rx="2.5"/><rect x="25" y="4.5" width="9" height="6.5" rx="2.5"/><path d="M11 15.5h17"/><path d="M28 15.5l9 9"/><path d="M28 15.5v9h9"/>',
    /* fotoliu: ca canapeaua, pentru un singur loc */
    fotoliu: '<rect x="13" y="7" width="22" height="20" rx="2.5"/><path d="M17.5 27V11.5h13V27"/>',
    stanga: '<path d="M7.5 5h33a2.5 2.5 0 0 1 2.5 2.5V19H18v8.5a2.5 2.5 0 0 1-2.5 2.5h-8A2.5 2.5 0 0 1 5 27.5v-20A2.5 2.5 0 0 1 7.5 5z"/><path d="M9.5 30V9.5h29V19"/>',
    simetric: '<rect x="5" y="9" width="38" height="16" rx="2.5"/><path d="M9.5 25V14h29v11"/>',
    dreapta: '<path d="M40.5 5h-33A2.5 2.5 0 0 0 5 7.5V19h25v8.5a2.5 2.5 0 0 0 2.5 2.5h8a2.5 2.5 0 0 0 2.5-2.5v-20A2.5 2.5 0 0 0 40.5 5z"/><path d="M38.5 30V9.5h-29V19"/>'
  };
  /* pictogramele mai inalte decat rama obisnuita de 48x34 */
  var TALL = { pat: 38 };
  function icon(v) {
    if (!ICONS[v]) return '';
    var head = TALL[v] ? SVG_HEAD.replace('0 0 48 34', '0 0 48 ' + TALL[v]).replace('height="34"', 'height="' + TALL[v] + '"') : SVG_HEAD;
    return head + ICONS[v] + '</svg>';
  }
  /* bifa dalei alese, ca in configurator (.cfg-shape-check) */
  var CHECK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>';
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ── Pagina ─────────────────────────────────────────────────────────── */
  var IMG_WIDTHS = [360, 540, 720, 900, 1080];

  function Plp(root) {
    this.root = root;
    var data = [];
    try {
      data = JSON.parse(root.querySelector('[data-ixp-data]').textContent);
    } catch (e) {
      console.warn('[ixaria-plp] datele produselor lipsesc', e);
    }
    /* HEX-ul culorilor (metaobiectele „Culoare swatch"), pentru filtrul de culoare */
    var swatch = swatchMap([]);
    try {
      swatch = swatchMap(JSON.parse(root.querySelector('[data-ixp-colors]').textContent));
    } catch (e) {}
    this.kind = root.getAttribute('data-kind') || '';
    this.kitchen = root.hasAttribute('data-kitchen');
    this.fromTpl = root.getAttribute('data-from') || 'De la %s';
    this.products = data.map(function (p) { return ixpFacts(p, this.kind, swatch); }, this);
    this.byIndex = {};
    this.products.forEach(function (p) { this.byIndex[p.i] = p; }, this);
    this.engine = new Engine(this.products);
    /* „Un card pentru fiecare formă": numerele din filtre numara formele (cardurile) */
    this.engine.perShape = root.getAttribute('data-per-shape') === 'true';
    limitTypes(this.engine, this.kind);
    this.sort = readQuery(this.engine, location.search);
    this.grid = root.querySelector('[data-ixp-grid]');
    this.layout = root.querySelector('[data-ixp-layout]');
    this.panel = root.querySelector('[data-ixp-panel]');
    this.tools = root.querySelector('.ixp-tools');
    /* „Toate filtrele" si butonul rosu din colt deschid aceeasi foaie */
    this.openBtns = root.querySelectorAll('[data-ixp-open]');
    /* pozele placilor de material (assets/ixaria-swatch-thumbs.js), pentru culorile din carduri */
    this.thumbs = window.IX_SWATCH_THUMBS || null;
    /* Cardurile, in ordinea din pagina (ordinea „Recomandate"): unul pe produs, sau
       unul pe forma (data-ixp-sid = gid-ul formei, cu setarea „Un card pentru
       fiecare formă"). Cardul unei forme nu se schimba, doar se arata sau nu. */
    this.items = [];
    var self = this;
    Array.prototype.forEach.call(root.querySelectorAll('[data-ixp-item]'), function (li, pos) {
      var i = +li.getAttribute('data-ixp-item'), track = li.querySelector('[data-ixp-track]');
      var shapeEl = li.querySelector('[data-ixp-shape]'), priceEl = li.querySelector('[data-ixp-price]');
      var bar = li.querySelector('[data-ixp-bar]');
      self.items.push({
        li: li,
        pi: i,
        sid: li.getAttribute('data-ixp-sid') || '',
        pos: pos,
        /* galeria de la incarcare (pozele si cate sunt), pusa inapoi cand nu mai e aleasa o forma */
        track: track,
        slides0: track ? track.innerHTML : '',
        bar: bar,
        n0: bar ? +bar.style.getPropertyValue('--n') || 1 : 1,
        colorsEl: li.querySelector('[data-ixp-colors-row]'),
        shapeEl: shapeEl,
        shape0: shapeEl ? shapeEl.innerHTML : '',
        shape0Hidden: shapeEl ? shapeEl.hidden : true,
        priceEl: priceEl,
        price0: priceEl ? priceEl.innerHTML : '',
        sale0: priceEl ? priceEl.classList.contains('is-sale') : false,
        saleEl: li.querySelector('[data-ixp-sale]'),
        links: li.querySelectorAll('[data-ixp-link]'),
        shown: null
      });
    });
    this.build();
    this.bind();
    this.bindSb();
    this.bindCards();
    this.bindBenefits();
    this.bindFab();
    this.bindNudge();
    this.bindView();
    this.linkShapeCards();
    this.render(false);
    root.classList.add('is-ready');
  }

  /* Forma unui card („Un card pentru fiecare formă") printre formele produsului. */
  function shapeById(p, sid) {
    for (var i = 0; p && i < p.shapes.length; i++) if (p.shapes[i].id === sid) return p.shapes[i];
    return null;
  }
  /* Linkurile cardurilor de forma (?forma=… din pagina) primesc si culoarea aleasa
     ultima data pe produs, ca linkurile cardurilor obisnuite (shapeUrl). */
  Plp.prototype.linkShapeCards = function () {
    var self = this;
    this.items.forEach(function (it) {
      if (!it.sid) return;
      var p = self.byIndex[it.pi], s = shapeById(p, it.sid);
      if (!s) return;
      var href = self.cardHref(p, s);
      for (var i = 0; i < it.links.length; i++) it.links[i].setAttribute('href', href);
    });
  };

  /* Cu un filtru de culoare, cardul deschide produsul in culoarea aleasa: din prima
     familie aleasa pe care o are produsul, placa lui cea mai apropiata de culoarea
     familiei (FILTERS.culoare: pick, altfel bulina), adica cea mai „verde" dintre cele
     verzi. O placa cu poze (pagina produsului o arata pe loc) castiga cat e aproape la fel
     de potrivita (PHOTO_SLACK, diferenta de culoare ΔE); altfel cea mai potrivita, chiar
     fara poze (pagina o randeaza). */
  var PHOTO_SLACK = 6;
  Plp.prototype.pickColor = function (p) {
    var sel = this.engine.sel.culoare || [], f = FILTERS.culoare;
    for (var i = 0; i < sel.length; i++) {
      var target = lab((f.pick && f.pick[sel[i]]) || f.dots[sel[i]]);
      var best = null, bestD = Infinity, photo = null, photoD = Infinity;
      for (var j = 0; j < p.palette.length; j++) {
        var c = p.palette[j];
        if (c.fam !== sel[i]) continue;
        var x = lab(c.hex), d = Math.sqrt(Math.pow(x.l - target.l, 2) + Math.pow(x.a - target.a, 2) + Math.pow(x.b - target.b, 2));
        if (d < bestD) {
          bestD = d;
          best = c;
        }
        if (c.photo && d < photoD) {
          photoD = d;
          photo = c;
        }
      }
      if (photo && photoD - bestD <= PHOTO_SLACK) return photo;
      if (best) return best;
    }
    return null;
  };
  /* Linkul cardului: forma lui (s) si culoarea aleasa. Un produs clasic se deschide pe
     varianta culorii; un card fara forma pastreaza forma aleasa ultima data pe produs. */
  Plp.prototype.cardHref = function (p, s) {
    var c = this.pickColor(p), sep = p.url.indexOf('?') === -1 ? '?' : '&';
    if (c && c.variant) return p.url + sep + 'variant=' + encodeURIComponent(c.variant);
    if (s && s.slug) return shapeUrl(p, s, c);
    if (!c) return p.url;
    var saved = savedLink(p, this.kind === 'colt' ? 'colt' : 'canapea') || {};
    return p.url + sep + (saved.forma ? 'forma=' + encodeURIComponent(saved.forma) + '&' : '') + 'culoare=' + encodeURIComponent(slug(c.name));
  };

  /* ── Filtrele de pe desktop ─────────────────────────────────────────── */
  /* Din 2026-10-07 filtrele sunt si pe desktop o foaie peste pagina (din dreapta, ca
     la Tylko), nu o coloana lipita langa grila: fit() doar curata ce punea coloana
     (top / max-height pe .ixp-panel), daca a ramas. */
  /* inaltimea antetului o pune header.js in --header-height; pana atunci, masurata */
  function headerH() {
    var h = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
    if (h > 0) return h;
    var el = document.querySelector('header[is="sticky-header"]');
    return el ? el.offsetHeight : 0;
  }
  Plp.prototype.fit = function () {
    var panel = this.panel;
    if (!panel || this.stick == null) return;
    panel.style.top = panel.style.maxHeight = panel.style.transition = '';
    this.stick = this.maxH = null;
  };
  /* Alte rezultate cand inceputul listei a ramas deasupra, sub antet sau in afara
     ferestrei: pagina urca (in spatele foii deschise) pana la „Toate filtrele", cu filtrele
     puse si primele produse sub el, ca la inchiderea foii lista sa inceapa de sus. Urcarea
     coboara antetul, deci locul se socoteste cu antetul coborat. Si pe telefon: acolo foaia
     se deschide si din butonul rosu, de oriunde din lista. */
  Plp.prototype.toResults = function () {
    var at = this.tools || this.layout;
    if (!at || !this.layout) return;
    if (this.layout.getBoundingClientRect().top >= (document.body.classList.contains('header-pinned') ? headerH() : 0)) return;
    var top = at.getBoundingClientRect().top + (at === this.tools ? parseFloat(getComputedStyle(at).paddingTop) || 0 : 0);
    window.scrollTo(0, Math.max(0, Math.round((window.pageYOffset || 0) + top - 16 - headerH())));
  };

  /* Grupurile de filtre, in ordinea blocurilor sectiunii. Un grup fara date in
     colectia asta (Fermitate, pana o completeaza cineva) nu se arata deloc. */
  Plp.prototype.build = function () {
    var engine = this.engine, kitchen = this.kitchen;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-group]'), function (el) {
      var facet = el.getAttribute('data-ixp-group');
      var keys = (FACETS[facet] || []).filter(function (k) { return engine.has(k); });
      if (!keys.length || el.closest('[data-ixp-panel]') === null) {
        el.hidden = true;
        return;
      }
      var title = el.getAttribute('data-label') || TITLES[facet];
      var html = '<h3 class="ixp-group__h">' + esc(title) + '</h3>';
      keys.forEach(function (k) {
        var f = FILTERS[k];
        if (f.kind === 'opts') {
          var tiles = k === 'tip' || k === 'directie';
          /* Culoare: ca filtrul de culoare din configurator (.cfg-fpill-color), un cerc in
             culoarea familiei cu numele sub el */
          var colors = !!f.dots;
          html += '<div class="ixp-opts' + (tiles ? ' ixp-opts--tiles' : '') + (colors ? ' ixp-opts--colors' : '') + '" role="group" aria-label="' + esc(title) + '">';
          /* fara numarul de produse pe optiuni: se vede pe butonul „Vezi … produse" si
             langa titlu; o optiune fara produse ramane doar stinsa (render) */
          engine.options[k].forEach(function (v) {
            var label = f.labels ? f.labels[v] : f.label(v);
            /* colțarele de bucătărie isi spun partea privite de pe bancă, invers fata de canapele
               (Andi / Andrei „stânga" au latura scurta in dreapta pozei, Andreea „dreapta" in
               stânga): pictograma intoarsa, ca dala sa arate ca poza (cerut 2026-10-08) */
            var pic = kitchen && k === 'directie' ? ({ stanga: 'dreapta', dreapta: 'stanga' }[v] || v) : v;
            html += '<button type="button" class="ixp-opt' + (colors ? ' ixp-opt--color' : '') + '" data-k="' + k + '" data-v="' + esc(v) + '" aria-pressed="false">' +
              (tiles ? '<span class="ixp-opt__box">' + icon(pic) + '<span class="ixp-opt__chk" aria-hidden="true">' + CHECK + '</span></span>' : '') +
              (colors ? '<span class="ixp-opt__sw" style="background:' + f.dots[v] + '" aria-hidden="true"></span>' : '') +
              '<span class="ixp-opt__lab">' + esc(label) + '</span></button>';
          });
          html += '</div>';
        } else {
          var b = engine.bounds[k], sub = keys.length > 1 || facet === 'marime';
          /* „Minim" / „Maxim" doar unde filtrul le cere (f.ends, pretul); fara ele, campurile
             isi primesc numele din aria-label */
          var lab = function (end, word) {
            return f.ends
              ? '<span class="ixp-range__l">' + word + '</span><span class="ixp-range__box"><input type="text" inputmode="numeric" class="ixp-range__in" data-end="' + end + '" autocomplete="off">'
              : '<span class="ixp-range__box"><input type="text" inputmode="numeric" class="ixp-range__in" data-end="' + end + '" autocomplete="off" aria-label="' + esc(f.label) + ' ' + word.toLowerCase() + '">';
          };
          html += '<div class="ixp-range' + (f.ends ? '' : ' ixp-range--bare') + '" data-k="' + k + '">' +
            (sub ? '<div class="ixp-range__h">' + esc(f.label) + '</div>' : '') +
            /* no-empty: tema ascunde orice div gol (theme.css, div:empty) */
            '<div class="ixp-range__track"><div class="ixp-range__fill no-empty"></div>' +
            '<input type="range" class="ixp-range__lo" min="' + b[0] + '" max="' + b[1] + '" step="' + f.step + '" value="' + b[0] + '" aria-label="' + esc(f.label) + ' minim">' +
            '<input type="range" class="ixp-range__hi" min="' + b[0] + '" max="' + b[1] + '" step="' + f.step + '" value="' + b[1] + '" aria-label="' + esc(f.label) + ' maxim">' +
            '</div><div class="ixp-range__vals">' +
            '<label class="ixp-range__f">' + lab(0, 'Minim') + '<em>' + f.unit + '</em></span></label>' +
            '<label class="ixp-range__f">' + lab(1, 'Maxim') + '<em>' + f.unit + '</em></span></label>' +
            '</div></div>';
        }
      });
      el.innerHTML = html;
      el.hidden = false;
    });
  };

  Plp.prototype.bind = function () {
    var self = this, root = this.root, engine = this.engine;
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-ixp-link]')) {
        if (self.urlTimer) self.saveUrl(true);
        return;
      }
      /* sortarea, primul grup din foaie */
      var sortBtn = e.target.closest('[data-ixp-sortv]');
      if (sortBtn) {
        var sv = sortBtn.getAttribute('data-ixp-sortv');
        self.sort = SORTS.indexOf(sv) !== -1 ? sv : '';
        return self.render(true);
      }
      var opt = e.target.closest('.ixp-opt');
      if (opt && !opt.disabled) {
        var ok = opt.getAttribute('data-k'), ov = opt.getAttribute('data-v');
        engine.toggle(ok, ov);
        self.render(true);
        if (engine.sel[ok].indexOf(ov) !== -1) self.trackPick(ok, ov);
        return;
      }
      var chip = e.target.closest('[data-ixp-chip]');
      if (chip) {
        var k = chip.getAttribute('data-k'), v = chip.getAttribute('data-v');
        if (v != null && FILTERS[k].kind === 'opts') engine.toggle(k, v);
        else engine.clear(k);
        return self.render(true);
      }
      if (e.target.closest('[data-ixp-clear]')) {
        engine.clearAll();
        return self.render(true);
      }
      var openBtn = e.target.closest('[data-ixp-open]');
      if (openBtn) {
        self.open();
        return self.track('plp_filters_opened', { button: openBtn.hasAttribute('data-ixp-fab') ? 'floating' : 'toolbar' });
      }
      if (e.target.closest('[data-ixp-close]') || e.target.closest('[data-ixp-apply]') || e.target === self.panel) return self.close();
    });
    /* glisoarele: pagina se reface cel mult o data pe cadru cat se trage */
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.classList && t.classList.contains('ixp-range__in')) {
        t.style.width = Math.max(2, t.value.length) + 0.4 + 'ch';
        return;
      }
      if (!t.classList || !t.classList.contains('ixp-range__lo') && !t.classList.contains('ixp-range__hi')) return;
      var box = t.closest('.ixp-range'), k = box.getAttribute('data-k');
      var lo = +box.querySelector('.ixp-range__lo').value, hi = +box.querySelector('.ixp-range__hi').value;
      /* manerul tras se opreste langa celalalt, nu trece peste el (minGap) */
      var gap = self.minGap(box, k);
      if (hi - lo < gap) {
        if (t.classList.contains('ixp-range__lo')) lo = hi - gap;
        else hi = lo + gap;
        t.value = t.classList.contains('ixp-range__lo') ? lo : hi;
      }
      engine.setRange(k, lo, hi);
      self.paintRange(box, k, [lo, hi]);
      self.schedule();
    });
    /* valorile scrise de mana: la Enter sau cand se paraseste campul */
    root.addEventListener('change', function (e) {
      var t = e.target;
      /* glisorul lasat (sau mutat din taste): intervalul ales, pentru PostHog si Ixaria */
      if (t.classList && (t.classList.contains('ixp-range__lo') || t.classList.contains('ixp-range__hi'))) {
        var rk = t.closest('.ixp-range').getAttribute('data-k');
        /* pagina refacuta acum (nu la cadrul urmator), ca evenimentul sa aiba numarul de produse nou */
        if (self.raf) {
          if (window.cancelAnimationFrame) cancelAnimationFrame(self.raf);
          else clearTimeout(self.raf);
          self.raf = 0;
          self.render(true);
        }
        if (engine.rng[rk]) self.trackPick(rk);
        return;
      }
      if (!t.classList || !t.classList.contains('ixp-range__in')) return;
      var box = t.closest('.ixp-range'), k = box.getAttribute('data-k');
      var b = engine.bounds[k], cur = engine.rng[k] || b;
      var v = parseInt(String(t.value).replace(/[^\d]/g, ''), 10);
      var next = cur.slice(), end = +t.getAttribute('data-end');
      next[end] = isFinite(v) ? Math.max(b[0], Math.min(b[1], v)) : b[end];
      /* si o valoare scrisa tine celalalt capat la distanta (minGap) */
      var gap = self.minGap(box, k);
      if (next[1] - next[0] < gap) {
        if (end === 0) next[0] = Math.max(b[0], next[1] - gap);
        else next[1] = Math.min(b[1], next[0] + gap);
        if (next[1] - next[0] < gap) {
          if (end === 0) next[1] = next[0] + gap;
          else next[0] = next[1] - gap;
        }
      }
      engine.setRange(k, next[0], next[1]);
      self.render(true);
      if (engine.rng[k]) self.trackPick(k);
    });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList && e.target.classList.contains('ixp-range__in')) {
        e.preventDefault();
        e.target.blur();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.panel && self.panel.classList.contains('is-open')) self.close();
    });
    /* plecat din pagina (spre un produs) inainte sa se scrie adresa: o scrie acum,
       ca butonul Inapoi sa aduca aceleasi filtre */
    window.addEventListener('pagehide', function () {
      if (self.urlTimer) self.saveUrl(true);
    });
    /* filtrele de pe desktop (fit): la derulare, cand antetul coboara sau urca, cand
       se schimba fereastra si o data dupa ce s-a incarcat tot (fonturi, poze de sus) */
    var fitRaf = 0;
    var runFit = function () {
      fitRaf = 0;
      self.fit();
    };
    var refit = function () {
      if (fitRaf) return;
      fitRaf = window.requestAnimationFrame ? requestAnimationFrame(runFit) : setTimeout(runFit, 16);
    };
    window.addEventListener('scroll', refit, { passive: true });
    window.addEventListener('resize', refit);
    window.addEventListener('load', refit);
    if (window.MutationObserver) new MutationObserver(refit).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    /* cat se trage de un glisor pagina nu urca la primul produs (antetul ar cobori si
       ar muta glisorul de sub deget); urca o data, cand e lasat */
    root.addEventListener('pointerdown', function (e) {
      var c = e.target.classList;
      if (c && (c.contains('ixp-range__lo') || c.contains('ixp-range__hi'))) self.dragging = true;
    });
    var release = function () {
      if (!self.dragging) return;
      self.dragging = false;
      if (self.pendingTop) {
        self.pendingTop = false;
        self.toResults();
      }
    };
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
    /* Inapoi din pagina produsului, cu pagina din memoria browserului (bfcache):
       linkurile cardurilor se refac, ca sa duca alegerea facuta acolo (savedLink). */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      self.items.forEach(function (it) { it.shown = null; });
      self.linkShapeCards();
      self.render(false);
    });
  };

  /* ── PostHog si Ixaria ──────────────────────────────────────────────── */
  /* Evenimentele filtrelor (cerut 2026-10-13), prin posthog-js pus de aplicatia PixieHog
     (window.posthog; fara el, blocat sau inca neincarcat, nu ajung acolo) si, de la 2026-10-27,
     la Ixaria cu Ixaria.track (coada din layout/theme.liquid). Pagina si vizitatorul le pun
     PostHog si motorul Ixaria singure; aici colectia, filtrele active (tip:coltar,
     pret:1000-5000) si cate produse se vad.
       plp_filters_opened   click pe „Toate filtrele" (button: toolbar) sau pe butonul rosu (floating)
       plp_filter_selected  o optiune bifata sau un interval ales (filter, value, value_label)
       benefit_card_opened  un card de beneficiu deschis cu „+" (bindBenefits) */
  Plp.prototype.track = function (name, props) {
    var engine = this.engine, active = [];
    KEYS.forEach(function (k) {
      if (!engine.isOn(k)) return;
      if (FILTERS[k].kind === 'opts') engine.sel[k].forEach(function (v) { active.push(k + ':' + v); });
      else active.push(k + ':' + engine.rng[k].join('-'));
    });
    var data = {
      collection: this.root.getAttribute('data-collection') || '',
      collection_title: this.root.getAttribute('data-collection-title') || '',
      active_filters: active,
      active_filters_count: active.length,
      results: this.shownCount
    };
    for (var key in props) if (Object.prototype.hasOwnProperty.call(props, key)) data[key] = props[key];
    try {
      var ph = window.posthog;
      if (ph && typeof ph.capture === 'function') ph.capture(name, data);
    } catch (e) {}
    try {
      if (window.Ixaria) window.Ixaria.track(name, data);
    } catch (e) {}
  };
  /* filtrul ales: optiunea v a lui k, sau intervalul lui k (fara v) */
  Plp.prototype.trackPick = function (k, v) {
    var f = FILTERS[k], props = { filter: k, filter_name: TITLES[k] || f.label || k };
    if (f.kind === 'opts') {
      props.value = v;
      props.value_label = f.labels ? f.labels[v] : f.label(v);
    } else {
      var r = this.engine.rng[k];
      props.value = r.join('-');
      props.value_label = fmt(r[0]) + ' – ' + fmt(r[1]) + ' ' + f.unit;
      props.min = r[0];
      props.max = r[1];
    }
    this.track('plp_filter_selected', props);
  };

  Plp.prototype.schedule = function () {
    var self = this;
    if (this.raf) return;
    var run = function () {
      self.raf = 0;
      self.render(true);
    };
    this.raf = window.requestAnimationFrame ? requestAnimationFrame(run) : setTimeout(run, 16);
  };

  /* aria-expanded pe ambele butoane care deschid foaia („Toate filtrele" si cel rosu) */
  Plp.prototype.expanded = function (on) {
    for (var i = 0; i < this.openBtns.length; i++) this.openBtns[i].setAttribute('aria-expanded', on ? 'true' : 'false');
  };

  Plp.prototype.open = function () {
    if (!this.panel) return;
    /* redeschisa cat inca se inchidea: ramane deschisa */
    clearTimeout(this.closeTimer);
    this.panel.classList.remove('is-closing');
    this.lastFocus = document.activeElement;
    /* fereastra (dialog) cat e deschisa, pe orice ecran */
    this.panel.setAttribute('role', 'dialog');
    this.panel.setAttribute('aria-modal', 'true');
    this.panel.classList.add('is-open');
    document.documentElement.classList.add('ixp-lock');
    this.expanded(true);
    var close = this.panel.querySelector('[data-ixp-close]');
    if (close) close.focus({ preventScroll: true });
    this.sbSync();
  };
  /* Se inchide cu animatia deschiderii pe dos (.is-closing, ixaria-plp.css); foaia
     dispare si pagina se deblocheaza la sfarsitul ei. silent: fara animatie si fara
     focus inapoi. Daca animatia nu ruleaza (fila ascunsa, „reduce motion"), se
     inchide oricum dupa 500ms (cea mai lunga animatie are 0.32s). */
  Plp.prototype.close = function (silent) {
    var panel = this.panel, self = this;
    if (!panel || !panel.classList.contains('is-open') || panel.classList.contains('is-closing')) return;
    panel.removeAttribute('role');
    panel.removeAttribute('aria-modal');
    this.expanded(false);
    if (!silent && this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
    var done = function () {
      clearTimeout(self.closeTimer);
      panel.removeEventListener('animationend', onEnd);
      panel.classList.remove('is-open', 'is-closing');
      document.documentElement.classList.remove('ixp-lock');
    };
    var onEnd = function (e) {
      if (e.target.classList && e.target.classList.contains('ixp-sheet')) done();
    };
    var still = silent || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (still) return done();
    panel.addEventListener('animationend', onEnd);
    panel.classList.add('is-closing');
    this.closeTimer = setTimeout(done, 500);
  };

  /* ── Bara de derulare a foii ───────────────────────────────────────── */
  /* Ca in foaia configuratorului (fsheetScrollbarSync): mereu vizibila cat timp
     filtrele sunt mai inalte decat foaia, pentru ca bara nativa de pe telefon apare
     doar in timpul derularii si nu spune ca mai e ceva dedesubt. Se poate trage. */
  Plp.prototype.sbSync = function () {
    var sb = this.sb, body = this.sbBody;
    if (!sb || !body) return;
    var view = body.clientHeight, total = body.scrollHeight;
    var show = !!this.panel && this.panel.classList.contains('is-open') && total > view + 1;
    sb.hidden = !show;
    if (!show) return;
    var inset = 8, trackH = view - inset * 2;
    var thumbH = Math.max(32, trackH * view / total);
    var maxScroll = total - view;
    sb.style.top = body.offsetTop + inset + 'px';
    sb.style.height = trackH + 'px';
    this.sbThumb.style.height = thumbH + 'px';
    this.sbThumb.style.transform = 'translateY(' + (maxScroll > 0 ? (trackH - thumbH) * body.scrollTop / maxScroll : 0) + 'px)';
  };
  Plp.prototype.bindSb = function () {
    var self = this;
    this.sb = this.root.querySelector('[data-ixp-sb]');
    this.sbBody = this.panel && this.panel.querySelector('.ixp-sheet__body');
    this.sbThumb = this.sb && this.sb.firstElementChild;
    if (!this.sb || !this.sbBody || !this.sbThumb) return;
    var body = this.sbBody, thumb = this.sbThumb;
    var sync = function () { self.sbSync(); };
    body.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    /* dimensiunile finale se stiu la sfarsitul animatiei de deschidere */
    this.panel.addEventListener('animationend', sync);
    /* grupurile se schimba (optiuni stinse, cipuri puse sau scoase) */
    if (window.MutationObserver) {
      new MutationObserver(function () { requestAnimationFrame(sync); })
        .observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    }
    var dragging = false, startY = 0, startTop = 0;
    thumb.addEventListener('pointerdown', function (e) {
      dragging = true;
      startY = e.clientY;
      startTop = body.scrollTop;
      thumb.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var room = self.sb.clientHeight - thumb.offsetHeight;
      if (room <= 0) return;
      body.scrollTop = startTop + (e.clientY - startY) * (body.scrollHeight - body.clientHeight) / room;
    });
    var end = function () { dragging = false; };
    thumb.addEventListener('pointerup', end);
    thumb.addEventListener('pointercancel', end);
  };

  /* Manerele glisoarelor (32px) nu trec unul peste altul (cerut 2026-10-08: pe telefon se
     incalecau si stricau foaia): intre centrele lor raman cel putin 44px pe sina — doua
     manere si o bara scurta intre ele —, adica diferenta de valoare de aici, rotunjita la
     pasul filtrului. Sina e cea vazuta acum (alta pe telefon, alta pe desktop). */
  var THUMB_PX = 32, MIN_PX = 44;
  Plp.prototype.minGap = function (box, k) {
    var b = this.engine.bounds[k], f = FILTERS[k], span = b ? b[1] - b[0] : 0;
    var track = box.querySelector('.ixp-range__track');
    var room = (track ? track.getBoundingClientRect().width : 0) - THUMB_PX;
    if (span <= 0 || room <= 0) return 0;
    return Math.min(span, Math.ceil(MIN_PX / room * span / f.step) * f.step);
  };

  Plp.prototype.paintRange = function (box, k, val) {
    var b = this.engine.bounds[k], span = b[1] - b[0] || 1, f = FILTERS[k];
    var lo = box.querySelector('.ixp-range__lo'), hi = box.querySelector('.ixp-range__hi');
    if (document.activeElement !== lo) lo.value = val[0];
    if (document.activeElement !== hi) hi.value = val[1];
    /* bara dintre manere: de la centrul unui maner la al celuilalt (manerul are 32px) */
    var fill = box.querySelector('.ixp-range__fill');
    var a = (val[0] - b[0]) / span, z = (val[1] - b[0]) / span;
    fill.style.left = 'calc(' + a * 100 + '% + ' + (16 - a * 32) + 'px)';
    fill.style.right = 'calc(' + (1 - z) * 100 + '% + ' + (16 - (1 - z) * 32) + 'px)';
    /* campul cat textul din el, ca unitatea sa stea langa numar */
    var ins = box.querySelectorAll('.ixp-range__in');
    for (var i = 0; i < 2; i++) {
      if (document.activeElement !== ins[i]) ins[i].value = fmt(val[i]);
      ins[i].style.width = Math.max(2, ins[i].value.length) + 0.4 + 'ch';
    }
    box.classList.toggle('is-on', !!this.engine.rng[k]);
    lo.setAttribute('aria-valuetext', fmt(val[0]) + ' ' + f.unit);
    hi.setAttribute('aria-valuetext', fmt(val[1]) + ' ' + f.unit);
  };

  Plp.prototype.chips = function () {
    var engine = this.engine, html = '';
    KEYS.forEach(function (k) {
      var f = FILTERS[k];
      if (f.kind === 'opts') {
        engine.sel[k].forEach(function (v) {
          var label = f.labels ? f.labels[v] : f.label(v);
          /* culoarea: cu bulina familiei, ca filtrele puse din configurator (.fsheet-achip-dot) */
          var dot = f.dots ? '<span class="ixp-chip__dot" style="background:' + f.dots[v] + '" aria-hidden="true"></span>' : '';
          html += '<button type="button" class="ixp-chip" data-ixp-chip data-k="' + k + '" data-v="' + esc(v) + '" aria-label="Scoate filtrul ' + esc(label) + '">' +
            dot + esc(label) + '<span class="ixp-chip__x" aria-hidden="true">✕</span></button>';
        });
      } else if (engine.rng[k]) {
        var r = engine.rng[k], label = f.label + ': ' + fmt(r[0]) + ' – ' + fmt(r[1]) + ' ' + f.unit;
        html += '<button type="button" class="ixp-chip" data-ixp-chip data-k="' + k + '" aria-label="Scoate filtrul ' + esc(label) + '">' +
          esc(label) + '<span class="ixp-chip__x" aria-hidden="true">✕</span></button>';
      }
    });
    if (html) html += '<button type="button" class="ixp-chip ixp-chip--clear" data-ixp-clear>Șterge tot</button>';
    return html;
  };

  Plp.prototype.render = function (fromUser) {
    var self = this, engine = this.engine;
    engine.prune();
    var res = engine.results(), byP = {};
    res.forEach(function (r) { byP[r.p.i] = r; });

    /* cardurile: al unui produs (forma potrivita sau cel obisnuit) sau al unei forme
       (se vede cat forma lui trece de filtre) */
    var order = [], hidden = [];
    this.items.forEach(function (it) {
      var r = byP[it.pi], show = false, price = 0;
      if (r && it.sid) {
        for (var i = 0; i < r.m.length; i++) {
          if (r.m[i].id === it.sid) {
            show = true;
            price = r.m[i].price;
            break;
          }
        }
      } else if (r && r.show) {
        show = true;
        price = r.price;
        self.paintCard(it, r);
      }
      it.li.hidden = !show;
      (show ? order : hidden).push({ it: it, price: price });
    });

    /* ordinea: Recomandate = ordinea din pagina; pretul e cel aratat pe card */
    if (this.sort === 'pret-crescator') order.sort(function (a, b) { return a.price - b.price || a.it.pos - b.it.pos; });
    else if (this.sort === 'pret-descrescator') order.sort(function (a, b) { return b.price - a.price || a.it.pos - b.it.pos; });
    else order.sort(function (a, b) { return a.it.pos - b.it.pos; });
    var want = order.concat(hidden).map(function (o) { return o.it.li; });
    var now = Array.prototype.slice.call(this.grid.children);
    if (want.some(function (li, i) { return now[i] !== li; })) {
      want.forEach(function (li) { self.grid.appendChild(li); });
    }

    /* filtrele: cate produse aduce fiecare optiune, ce e ales, glisoarele */
    Array.prototype.forEach.call(this.root.querySelectorAll('.ixp-opt[data-k]'), function (b) {
      var k = b.getAttribute('data-k'), v = b.getAttribute('data-v');
      var on = engine.sel[k].indexOf(v) !== -1, n = engine.count(k, v);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      b.disabled = !on && n === 0;
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('.ixp-range'), function (box) {
      var k = box.getAttribute('data-k');
      self.paintRange(box, k, engine.rng[k] || engine.bounds[k]);
    });

    var chips = this.chips();
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-chips]'), function (el) {
      el.innerHTML = chips;
      el.hidden = !chips;
    });

    var n = order.length, active = engine.activeCount();
    this.shownCount = n;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-count]'), function (el) {
      el.textContent = plural(n, 'produs', 'produse');
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-nsel]'), function (el) {
      el.textContent = active ? String(active) : '';
      el.hidden = !active;
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-apply]'), function (el) {
      el.textContent = n ? 'Vezi ' + plural(n, 'produs', 'produse') : 'Niciun produs';
    });
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-reset]'), function (el) {
      el.disabled = !active;
    });
    var empty = this.root.querySelector('[data-ixp-empty]');
    if (empty) empty.hidden = n > 0;
    /* sortarea aleasa, in foaie */
    var sort = this.sort;
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-ixp-sortv]'), function (b) {
      var on = b.getAttribute('data-ixp-sortv') === sort;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    /* alta culoare aleasa: alt link pe cardurile de forma, alta culoare intai in carduri */
    var colSig = (engine.sel.culoare || []).join(',');
    if (colSig !== this.colSig) {
      this.colSig = colSig;
      this.linkShapeCards();
      this.paintColors();
    }
    /* alte rezultate (sau alta ordine): lista de produse incepe iar de sus */
    var sig = order.map(function (o) {
      var r = byP[o.it.pi];
      return o.it.pos + (r && r.shape && !o.it.sid ? ':' + r.shape.id : '');
    }).join(',');
    if (fromUser && sig !== this.lastSig) {
      if (this.dragging) this.pendingTop = true;
      else this.toResults();
    }
    this.lastSig = sig;
    /* primul card s-a putut schimba: indiciul de galerie tinteste noul prim card */
    if (this.aimNudge) this.aimNudge();
    /* cipurile de deasupra si lista mai scurta muta filtrele: se remasoara */
    this.fit();

    if (fromUser) this.saveUrl();
  };

  /* Adresa se scrie la 250ms dupa ultima schimbare: cat se trage de un glisor
     pagina se reface la fiecare cadru, iar Safari arunca o eroare dupa ~100 de
     history.replaceState intr-un interval scurt. */
  Plp.prototype.saveUrl = function (now) {
    var self = this;
    clearTimeout(this.urlTimer);
    this.urlTimer = 0;
    var write = function () {
      self.urlTimer = 0;
      if (!window.history || !history.replaceState) return;
      var next = location.pathname + writeQuery(self.engine, self.sort, location.search) + location.hash;
      if (next === location.pathname + location.search + location.hash) return;
      try {
        history.replaceState(history.state, '', next);
      } catch (e) {}
    };
    if (now) write();
    else this.urlTimer = setTimeout(write, 250);
  };

  /* Cardul: forma potrivita (poza, numele, pretul, linkul) sau cel de la incarcare. */
  Plp.prototype.paintCard = function (c, r) {
    var p = r.p, s = r.shape, col = this.pickColor(p);
    var key = (s ? s.id + '|' + r.n : '') + '|' + (col ? col.name : '');
    if (c.shown === key) return;
    c.shown = key;
    var href = this.cardHref(p, s);
    for (var i = 0; i < c.links.length; i++) c.links[i].setAttribute('href', href);

    /* galeria: a formei aratate (cel mult 5 poze), altfel cea de la incarcare */
    if (c.track) {
      var imgs = s && s.imgs && s.imgs.length ? s.imgs.slice(0, 5) : null;
      var gal = imgs ? imgs.join('|') : '';
      if (gal !== (c.gal || '')) {
        c.gal = gal;
        if (imgs) {
          var first = c.track.querySelector('img'), sizes = first ? first.getAttribute('sizes') || '' : '';
          var alt = p.title + (s.label ? ' – ' + s.label : '');
          c.track.innerHTML = imgs.map(function (src, k) {
            var base = src + (src.indexOf('?') === -1 ? '?' : '&');
            var set = IMG_WIDTHS.map(function (w) { return base + 'width=' + w + ' ' + w + 'w'; }).join(', ');
            return '<img class="ixp-card__img" src="' + esc(base + 'width=720') + '" srcset="' + esc(set) + '" sizes="' + esc(sizes) +
              '" width="1080" height="1080" loading="' + (k ? 'lazy' : 'eager') + '" alt="' + (k ? '' : esc(alt)) + '" draggable="false">';
          }).join('');
        } else {
          c.track.innerHTML = c.slides0;
        }
        c.track.scrollLeft = 0;
        c.track.ixpAwake = false;
        this.setBar(c, imgs ? imgs.length : c.n0);
        galleryEnds(c.track);
      }
    }

    if (c.shapeEl) {
      if (s) {
        var more = r.n - 1;
        c.shapeEl.innerHTML = esc(s.label) + (more > 0 ? ' <span class="ixp-card__more">+ încă ' + plural(more, 'formă', 'forme') + '</span>' : '');
        c.shapeEl.hidden = false;
      } else {
        c.shapeEl.innerHTML = c.shape0;
        c.shapeEl.hidden = c.shape0Hidden;
      }
    }

    if (c.priceEl) {
      /* redus („Reducere" + pretul rosu): al formei aratate, altfel cum a venit din pagina */
      var sale = c.sale0;
      if (s) {
        var now = this.fromTpl.replace('%s', money(s.price));
        sale = s.cmp > s.price;
        c.priceEl.innerHTML = '<span class="ixp-price__now">' + esc(now) + '</span>' +
          (sale ? ' <s class="ixp-price__was">' + esc(money(s.cmp)) + '</s>' : '');
      } else {
        c.priceEl.innerHTML = c.price0;
      }
      c.priceEl.classList.toggle('is-sale', sale);
      if (c.saleEl) c.saleEl.hidden = !sale;
    }
  };

  /* ── Galeriile din carduri, banda de beneficii ─────────────────────── */
  /* Bara de progres a galeriei: o bucata cat o poza (--n), mutata cat s-a tras (--p, 0…1). */
  Plp.prototype.setBar = function (c, n) {
    if (!c.bar) return;
    c.bar.hidden = n < 2;
    c.bar.style.setProperty('--n', n);
    c.bar.style.setProperty('--p', 0);
  };
  /* Sagetile galeriei (CSS): are mai multe poze (has-more), e pe prima (is-first), pe ultima (is-last). */
  function galleryEnds(t) {
    var m = t.parentNode, max = t.scrollWidth - t.clientWidth;
    if (!m) return;
    m.classList.toggle('has-more', max > 1);
    m.classList.toggle('is-first', t.scrollLeft <= 1);
    m.classList.toggle('is-last', t.scrollLeft >= max - 1);
  }
  /* latimea unui pas al galeriei: o poza plus golul dintre poze */
  function galleryStep(t) {
    return t.clientWidth + (parseFloat(getComputedStyle(t).columnGap) || 0);
  }
  Plp.prototype.bindCards = function () {
    var root = this.root, pending = [], raf = 0;
    var paint = function () {
      raf = 0;
      pending.splice(0).forEach(function (t) {
        galleryEnds(t);
        var bar = t.parentNode && t.parentNode.querySelector('[data-ixp-bar]');
        if (!bar) return;
        var max = t.scrollWidth - t.clientWidth;
        bar.style.setProperty('--p', max > 0 ? Math.min(1, Math.max(0, t.scrollLeft / max)) : 0);
      });
    };
    Array.prototype.forEach.call(root.querySelectorAll('[data-ixp-track]'), galleryEnds);
    /* sagetile: o poza inainte sau inapoi */
    root.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ixp-arr]');
      var t = b && b.parentNode.querySelector('[data-ixp-track]');
      if (!t) return;
      var w = galleryStep(t), last = Math.round((t.scrollWidth - t.clientWidth) / w);
      var to = Math.round(t.scrollLeft / w) + (+b.getAttribute('data-ixp-arr') || 0);
      t.scrollTo({ left: Math.max(0, Math.min(last, to)) * w, behavior: 'smooth' });
    });
    /* scroll nu urca pana la radacina; se prinde la coborare (capture) */
    root.addEventListener('scroll', function (e) {
      var t = e.target;
      if (!t.hasAttribute || !t.hasAttribute('data-ixp-track')) return;
      if (pending.indexOf(t) === -1) pending.push(t);
      if (!raf) raf = window.requestAnimationFrame ? requestAnimationFrame(paint) : setTimeout(paint, 16);
    }, true);
    /* Pozele din afara galeriei (loading="lazy") se cer cand degetul sau mouse-ul ajunge pe
       ea: altfel ar aparea goale chiar cand se trag. */
    root.addEventListener('pointerover', function (e) {
      var t = e.target.closest && e.target.closest('[data-ixp-track]');
      if (!t || t.ixpAwake) return;
      t.ixpAwake = true;
      Array.prototype.forEach.call(t.querySelectorAll('img[loading="lazy"]'), function (img) {
        img.loading = 'eager';
      });
    });
    /* Cu mouse-ul galeriile si banda de beneficii se trag (pe telefon si cu trackpad-ul se
       deruleaza singure). Galeria se opreste pe poza spre care s-a tras, daca s-a tras macar
       15% din ea; clicul de la sfarsitul tragerii nu deschide produsul. */
    var drag = null, swallow = false;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      var el = e.target.closest('[data-ixp-drag]');
      if (!el || el.scrollWidth <= el.clientWidth + 1) return;
      drag = { el: el, x: e.clientX, left: el.scrollLeft, moved: false };
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 6) return;
        drag.moved = true;
        drag.el.classList.add('is-drag');
      }
      drag.el.scrollLeft = drag.left - dx;
    });
    var end = function () {
      if (!drag) return;
      var d = drag, el = d.el;
      drag = null;
      if (!d.moved) return;
      swallow = true;
      setTimeout(function () { swallow = false; }, 0);
      if (!el.hasAttribute('data-ixp-track')) return el.classList.remove('is-drag');
      var w = galleryStep(el);
      var at = el.scrollLeft / w, last = Math.round((el.scrollWidth - el.clientWidth) / w);
      var to = el.scrollLeft > d.left ? Math.ceil(at - 0.15) : Math.floor(at + 0.15);
      el.scrollTo({ left: Math.max(0, Math.min(last, to)) * w, behavior: 'smooth' });
      /* prinderea de poze revine dupa ce galeria a ajuns */
      setTimeout(function () { el.classList.remove('is-drag'); }, 450);
    };
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    root.addEventListener('click', function (e) {
      if (!swallow) return;
      swallow = false;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  };

  /* ── Beneficiile: „+" deschide cardul ──────────────────────────────── */
  /* Poza se stinge si in locul ei apar titlul si subtitlul (sections/ixaria-plp.liquid, cerut
     2026-10-21). Tinta e tot cardul, nu doar butonul; cate un card deschis odata (cel deschis
     inainte se inchide). Un text care nu incape se deruleaza (.is-over: loc dedesubt pentru
     buton), cu bara desenata .ixp-ben__bar (.is-scroll pe card). Clicul de la sfarsitul unei
     trageri a benzii nu ajunge aici (bindCards il opreste). Fiecare card deschis trimite
     benefit_card_opened (ca pe pagina de produs, ixaria-pdp.js): numele beneficiului in engleza
     (snippets/ixaria-benefit-name.liquid), handle-ul cardului, titlul romanesc si pozitia in
     banda; colectia si filtrele le pune track. */
  Plp.prototype.bindBenefits = function () {
    var self = this, band = this.root.querySelector('.ixp-ben');
    if (!band) return;
    var set = function (card, open) {
      card.classList.toggle('is-open', open);
      var btn = card.querySelector('.ixp-ben__plus'), back = card.querySelector('.ixp-ben__back');
      if (btn) {
        btn.setAttribute('aria-expanded', open);
        btn.setAttribute('aria-label', open ? 'Închide detaliile' : 'Mai multe detalii');
      }
      if (!back) return;
      back.setAttribute('aria-hidden', !open);
      back.scrollTop = 0;
      back.classList.remove('is-over');
      var over = open && back.scrollHeight > back.clientHeight + 1;
      back.classList.toggle('is-over', over);
      card.classList.toggle('is-scroll', over);
      if (over) paint(back);
    };
    /* Bara de derulare desenata (.ixp-ben__bar, mereu vizibila cat textul nu incape): cat din
       text se vede si unde, si se poate trage; clicul pe ea nu inchide cardul. */
    var paint = function (back) {
      var bar = back.parentNode.querySelector('.ixp-ben__bar');
      if (!bar) return;
      var track = bar.clientHeight, sh = back.scrollHeight, ch = back.clientHeight;
      var h = Math.max(16, Math.round(track * ch / sh));
      var y = sh > ch ? Math.round((track - h) * back.scrollTop / (sh - ch)) : 0;
      bar.style.setProperty('--ixb-h', h + 'px');
      bar.style.setProperty('--ixb-y', y + 'px');
    };
    band.addEventListener('scroll', function (e) {
      if (e.target.classList && e.target.classList.contains('ixp-ben__back')) paint(e.target);
    }, true);
    var grab = null;
    band.addEventListener('pointerdown', function (e) {
      var bar = e.target.closest && e.target.closest('.ixp-ben__bar');
      if (!bar) return;
      /* nu porneste si tragerea benzii (bindCards) */
      e.stopPropagation();
      e.preventDefault();
      var back = bar.parentNode.querySelector('.ixp-ben__back'), thumb = bar.querySelector('i');
      var r = bar.getBoundingClientRect(), t = thumb.getBoundingClientRect();
      var room = (back.scrollHeight - back.clientHeight) / Math.max(1, r.height - t.height);
      /* pe sina, nu pe bara: textul sare intai acolo */
      if (e.clientY < t.top || e.clientY > t.bottom) back.scrollTop = (e.clientY - r.top - t.height / 2) * room;
      grab = { back: back, y: e.clientY, top: back.scrollTop, room: room };
    });
    window.addEventListener('pointermove', function (e) {
      if (grab) grab.back.scrollTop = grab.top + (e.clientY - grab.y) * grab.room;
    });
    var drop = function () { grab = null; };
    window.addEventListener('pointerup', drop);
    window.addEventListener('pointercancel', drop);
    band.addEventListener('click', function (e) {
      var card = e.target.closest('.ixp-ben__item--flip');
      if (!card || e.target.closest('.ixp-ben__bar')) return;
      var open = !card.classList.contains('is-open');
      if (open) {
        Array.prototype.forEach.call(band.querySelectorAll('.ixp-ben__item--flip.is-open'), function (c) {
          set(c, false);
        });
      }
      set(card, open);
      if (!open) return;
      var title = card.querySelector('.ixp-ben__t');
      self.track('benefit_card_opened', {
        benefit_name: card.getAttribute('data-benefit') || '',
        benefit_id: card.getAttribute('data-benefit-id') || '',
        benefit_title: title ? title.textContent.trim() : '',
        page_type: 'plp',
        position: Array.prototype.indexOf.call(band.children, card) + 1
      });
    });
  };

  /* ── Indiciul de galerie (ca la Kave Home) ─────────────────────────── */
  /* Primul card cu mai multe poze isi misca singur galeria cand intra in ecran: pozele aluneca
     de doua ori 20% spre stanga si inapoi (2s, ixpNudge in ixaria-plp.css), ca sa se vada ca
     se pot trage. Pe telefon si pe desktop; o singura data pe pagina, nu si cu „reduce
     motion"; se opreste cand galeria e atinsa, trasa sau derulata. Se misca pozele din banda,
     nu banda: ea e cea care se deruleaza (si taie ce iese din ea). */
  Plp.prototype.bindNudge = function () {
    var mm = window.matchMedia;
    if (!window.IntersectionObserver || !mm || !this.grid) return;
    if (mm('(prefers-reduced-motion: reduce)').matches) return;
    var grid = this.grid, target = null, timer = 0, done = false;
    var stop = function (t) {
      t.classList.remove('is-nudge');
    };
    var play = function (t) {
      if (done || t !== target || !t.isConnected) return;
      /* galeria a fost deja trasa, sau are o singura poza */
      if (t.scrollLeft > 1 || t.scrollWidth <= t.clientWidth + 1) return;
      done = true;
      io.disconnect();
      var go = function () {
        if (t.scrollLeft > 1) return;
        t.classList.add('is-nudge');
        t.addEventListener('animationend', function () { stop(t); }, { once: true });
        t.addEventListener('pointerdown', function () { stop(t); }, { once: true });
        t.addEventListener('scroll', function () { stop(t); }, { once: true });
      };
      /* a doua poza (loading="lazy") trebuie sa fie gata, altfel se vede o bucata goala */
      var next = t.querySelectorAll('img')[1];
      if (!next || (next.complete && next.naturalWidth)) return go();
      next.loading = 'eager';
      var once = false, ready = function () {
        if (once) return;
        once = true;
        go();
      };
      next.addEventListener('load', ready, { once: true });
      setTimeout(ready, 1500);
    };
    /* cand cardul e mai mult de 60% in ecran, dupa un sfert de secunda (scroll-ul se opreste) */
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.target !== target) return;
        clearTimeout(timer);
        if (en.intersectionRatio >= 0.6) timer = setTimeout(function () { play(en.target); }, 250);
      });
    }, { threshold: [0, 0.6] });
    /* primul card aratat care are mai multe poze (dupa filtre si sortare) */
    this.aimNudge = function () {
      if (done) return;
      var t = null, lis = grid.children;
      for (var i = 0; i < lis.length && !t; i++) {
        var tr = !lis[i].hidden && lis[i].querySelector('[data-ixp-track]');
        if (tr && tr.scrollWidth > tr.clientWidth + 1) t = tr;
      }
      if (t === target) return;
      clearTimeout(timer);
      if (target) io.unobserve(target);
      target = t;
      if (t) io.observe(t);
    };
  };

  /* ── Grila / lista ──────────────────────────────────────────────────── */
  /* Butoanele din stanga lui „Toate filtrele", doar pe telefon (de la tableta CSS-ul le ascunde si
     tine coloanele setarii). Alegerea ramane in browser (localStorage
     ixaria:plp-view); fara ea, pe telefon conteaza setarea sectiunii (o coloana = lista), altfel
     grila — ca in scriptul din ixaria-plp.liquid, care o pune inainte sa apara produsele. La
     schimbare pozele primesc alt `sizes` (data-sizes-grid / -list), iar galeriile raman pe aceeasi
     poza (latimea lor s-a schimbat). */
  var VIEW_KEY = 'ixaria:plp-view';
  Plp.prototype.bindView = function () {
    var root = this.root, btns = root.querySelectorAll('[data-ixp-view]'), self = this;
    if (!btns.length) return;
    var phone = window.matchMedia ? window.matchMedia('(max-width: 767.98px)') : null;
    var saved = function () {
      var v = null;
      try {
        v = localStorage.getItem(VIEW_KEY);
      } catch (e) {}
      return v === 'grid' || v === 'list' ? v : null;
    };
    var fallback = function () {
      return phone && phone.matches && root.getAttribute('data-cols-m') === '1' ? 'list' : 'grid';
    };
    var apply = function (v) {
      Array.prototype.forEach.call(btns, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-ixp-view') === v ? 'true' : 'false');
      });
      /* si la intrare: pozele din Liquid au `sizes` dupa setarea sectiunii, nu dupa alegere */
      var sizes = root.getAttribute('data-sizes-' + v);
      if (sizes) {
        Array.prototype.forEach.call(root.querySelectorAll('.ixp-card__img[sizes]'), function (img) {
          if (img.getAttribute('sizes') !== sizes) img.setAttribute('sizes', sizes);
        });
      }
      if (root.getAttribute('data-view') === v) return;
      var tracks = root.querySelectorAll('[data-ixp-track]');
      var at = Array.prototype.map.call(tracks, function (t) {
        return t.scrollLeft > 1 ? Math.round(t.scrollLeft / galleryStep(t)) : 0;
      });
      root.setAttribute('data-view', v);
      Array.prototype.forEach.call(tracks, function (t, k) {
        if (at[k]) t.scrollLeft = at[k] * galleryStep(t);
        galleryEnds(t);
      });
      if (self.aimNudge) self.aimNudge();
    };
    apply(saved() || root.getAttribute('data-view') || fallback());
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ixp-view');
        try {
          localStorage.setItem(VIEW_KEY, v);
        } catch (e) {}
        apply(v);
      });
    });
    /* fara alegere, telefonul si desktopul pot avea alta vizualizare implicita */
    var onPhone = function () {
      if (!saved()) apply(fallback());
    };
    if (phone && phone.addEventListener) phone.addEventListener('change', onPhone);
    else if (phone && phone.addListener) phone.addListener(onPhone);
  };

  /* ── Butonul rosu din colt ─────────────────────────────────────────── */
  /* Sub 1200px (pe desktop CSS-ul il ascunde): apare cand „Toate filtrele" a iesit din ecran
     pe sus si inca se vad produse; dispare la subsol si cand butonul mare revine in ecran. */
  Plp.prototype.bindFab = function () {
    var fab = this.root.querySelector('[data-ixp-fab]'), btn = this.tools && this.tools.querySelector('[data-ixp-open]');
    if (!fab || !btn || !this.grid || !window.IntersectionObserver) return;
    var above = false, gridIn = false;
    var sync = function () {
      fab.classList.toggle('is-on', above && gridIn);
    };
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        above = !en.isIntersecting && en.boundingClientRect.bottom <= 0;
      });
      sync();
    }).observe(btn);
    new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        gridIn = en.isIntersecting;
      });
      sync();
    }).observe(this.grid);
  };

  /* ── Culorile din carduri ──────────────────────────────────────────── */
  /* Cel mult 5 placi, cu pozele lor din aplicatie (assets/ixaria-swatch-thumbs.js; pana se
     incarca, sau fara poza, culoarea HEX), apoi „+N culori" pentru restul. Intai culoarea
     aleasa de filtrul de culoare (cu ea deschide cardul produsul), apoi cele cu poze, in
     ordinea din aplicatie. Prima are chenarul negru, ca in Figma. */
  var SWATCHES = 5;
  Plp.prototype.paintColors = function () {
    var self = this, th = this.thumbs, base = (th && th.base) || '', files = (th && th.ids) || {};
    this.items.forEach(function (it) {
      if (!it.colorsEl) return;
      var p = self.byIndex[it.pi], pal = p ? p.palette : [];
      if (!pal.length) {
        it.colorsEl.hidden = true;
        return;
      }
      var pick = self.pickColor(p), list = pal;
      if (pick) list = [pick].concat(pal.filter(function (c) { return c !== pick; }));
      var show = list.slice(0, SWATCHES), more = pal.length - show.length;
      var html = '<span class="ixp-sws">' + show.map(function (c, k) {
        var file = c.id && files[c.id];
        var fill = file
          ? '<img src="' + esc(base + file) + '" alt="" width="12" height="12" loading="lazy" decoding="async" draggable="false" style="background:' + esc(c.hex) + '">'
          : '<i style="background:' + esc(c.hex) + '"></i>';
        return '<span class="ixp-sw' + (k ? '' : ' is-on') + '">' + fill + '</span>';
      }).join('') + '</span>';
      if (more > 0) html += '<span class="ixp-card__ncol ixp-t">+' + more + (more === 1 ? ' culoare' : ' culori') + '</span>';
      it.colorsEl.innerHTML = html;
      it.colorsEl.hidden = false;
    });
  };

  function boot() {
    var roots = document.querySelectorAll('[data-ixp]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].ixpPlp) roots[i].ixpPlp = new Plp(roots[i]);
    }
  }

  return {
    boot: function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
      else boot();
      /* editorul de teme reface sectiunea */
      document.addEventListener('shopify:section:load', boot);
    },
    ixpFacts: ixpFacts,
    colorFamily: colorFamily,
    swatchMap: swatchMap,
    parseDims: parseDims,
    Engine: Engine,
    readQuery: readQuery,
    writeQuery: writeQuery,
    plural: plural,
    pretty: pretty,
    slug: slug
  };
});
